module.exports = __webpack_public_path__ + "img/login-bg1.d135cde6.png";